<script lang="ts">
	//Hooks
	import { onMount } from 'svelte';
	//Services
	import { format } from '../../../../../services/i18n';
	import { gen2Request } from '../../../../../services/gen_2_http_reqs';
	//Stores
		import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Helpers
	import { real_id } from '../../../../../helpers/interface_helpers';
	//Types
	import type { SettingRequest } from '../../../../../types/requests/settings/setting';
	//Design system components
	import { Button, Container, Radio, Text, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);

	const inputOptions = ['button', 'switch'];
	const _input_options_i18n = [$format('working_type_button'), $format('working_type_switch')];

	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;
	$: inputs_counter = Object.keys($settingsStore ?? {}).reduce((r, v) => {
		return v.includes('input') && Number(v.split(':')[1]) < 10 ? (r = r + 1) : r;
	}, 0);

	let inputTypes = {},
		loading = false,
		cache;

	onMount(() => {
		// Object.keys(settings).forEach(channel => {
		// if (channel.includes('input')) {
		// 	type[inputs_counter] = settings[`input:${inputs_counter}`].type;
		// 	++inputs_counter;
		// }
		// });
		for (let count of Array(inputs_counter).keys()) {
			//so it was needed to change all input types with one command for rollers
			inputTypes[count] = settings[`input:${count}`].type;
		}

		cache = Object.assign({}, { ...inputTypes });
	});

	const setInputType = (value) => {
		for (let count of Array(inputs_counter).keys()) {
			inputTypes[count] = value;
		}
	};

	const sentRequest = async () => {
		if (JSON.stringify(cache) !== JSON.stringify(inputTypes)) {
			let isok = false;
			loading = true;
			for (let input in inputTypes) {
				let params = { id: input, config: { type: inputTypes[input] } };

				const res: SettingRequest = await gen2Request(device, 'Input.SetConfig', params);

				if (res.isok) {
					settings[`input:${input}`].type = inputTypes[input];
					isok = true;
					cache[input] = inputTypes[input];
					devices_settings.update_devices_settings(device.id, settings);
				} else {
					toast.open({
						type: 'danger',
						title: $format('input_type_err_toast') || 'Error! Could not change input mode.',
					});
					isok = false;
					inputTypes[input] = cache[input];
				}
				loading = false;
			}
			if (isok)
				toast.open({
					type: 'success',
					title: $format('input_type_scc_toast', {
						values: { mode_value: inputTypes[0] },
					}),
				});
		}
	};
</script>

<Text element="h2" styleType="h2" class="mb-s">
	{$format('input_type_desc', { default: 'Set input type' })}
</Text>

{#each inputOptions as option, index}
	<Radio
		size="m"
		selected={option}
		value={inputTypes[index]}
		on:click={() => setInputType(option)}
		id="radio-bunqqqh"
	>
		{_input_options_i18n[index]}
	</Radio>
{/each}

<Button class="mt-s" {loading} size="m" width="full" on:click={sentRequest}>
	{$format('button_save')}
</Button>
